import axios from '../../util/axios';
// import '../../util/mock/getParkOverviewInfo';

import {
    runTableScrollAnim,
    runRoamByPath,
    runNumberGrowth
} from '../../util/Animation';
import {
    ROAM_PATH_CONFIG
} from '../../util/constant';
import {
    startAnim,
} from '../../util/util';
import Easing from '../../util/Easing';
import config from '../../config/config';

/**
 * 园区总览 
 */
export default class ParkOverview {
    constructor(main) {
        this.main = main;
        this.g2d = main.g2d;
        this.dm = main.g2d.dm();
        this.entInfoNumber = 0;
        this.htAnims = {};
        this.movingTrackCars = {};
        this.movingTrackCarsTooltip = {};
    }

    /**
     * 初始化 2D 面板上的数据
     */
    init() {
        const dm = this.dm;
        // 左侧
        const parkOverviewPanel = this.parkOverviewPanel = dm.getDataByTag('parkOverviewPanel');
        const regionAreaChart = this.regionAreaChart = dm.getDataByTag('regionAreaChart');
        this.regionAreaChartBG = dm.getDataByTag('regionAreaChartBG');
        const parkEnterprisePanel = this.parkEnterprisePanel = dm.getDataByTag('parkEnterprisePanel');
        const parkEnterpriseChart = this.parkEnterpriseChart = dm.getDataByTag('parkEnterpriseChart');
        // 右侧
        const parkInfoPanel = this.parkInfoPanel = dm.getDataByTag('parkInfoPanel');
        const parkEventPanel = this.parkEventPanel = dm.getDataByTag('parkEventPanel');

        // 重置数据
        parkOverviewPanel.a({
            area: 0,
            useArea: 0,
            people: 0,
            entCount: 0
        });

        axios.get('getParkOverviewInfo').then(res => {
            this.subjectDatas = res;
            // parkOverviewPanel.a(res.overviewInfo);
            parkEnterprisePanel.a(res.regionEnt[0]);
            parkEnterpriseChart.a({
                axisData: Object.keys(res.regionEnt[0].ent),
                seriesData1: Object.values(res.regionEnt[0].ent),
            });

            regionAreaChart.a('ht.dataSource', res.regionArea);
            parkInfoPanel.a(res.parkInformation);
            parkEventPanel.a('ht.dataSource', res.parkEvents);

            this.start2DAnim();
        });
    }

    /**
     * 启动 2D 上的动画
     */
    start2DAnim() {
        // 先清除动画,避免重复调用 start2DAnim 但未调用过 stop2DAnim 的误操作.
        this.stop2DAnim();

        const subjectDatas = this.subjectDatas;

        // 左一的动画
        this.htAnims.overViewValueAnim = runNumberGrowth(this.parkOverviewPanel, subjectDatas.overviewInfo, 0, {
            duration: 5000
        });

        // 左二的动画
        this.htAnims.areaOutCircleAnim = startAnim({
            duration: 3000,
            easing: Easing.bounceOut,
            action: v => {
               this.regionAreaChartBG.a('outCircle', Math.PI * v);
            },
            finishFunc: () => {
            }
        });
        this.htAnims.parkInfoInnerCircleAnim = ht.Default.startAnim({
            interval: 20,
            frames: Infinity,
            action: () => {
                const currentAngle = this.regionAreaChartBG.a('circleRotation') || 0;
                this.regionAreaChartBG.a('circleRotation', currentAngle + Math.PI / 90);
            }
        });
        

        // 左三的数据切换及动画
        let chartData = subjectDatas.regionEnt[this.entInfoNumber];
        let xData = Object.keys(chartData.ent);
        let seriseData = Object.values(chartData.ent);
        this.parkEnterpriseChart.a({
            axisData: xData,
            seriesData1: seriseData,
        });
        let offsetValue = seriseData.map(v2 => v2);
        let oldData = seriseData.map(v2 => v2);
        const enterpriseParam = {
            delay: 3000,
            duration: 1000,
            easing: t => t,
            action: v => {
                this.parkEnterprisePanel.a(chartData);
                this.parkEnterpriseChart.a({
                    axisData: xData,
                    seriesData1: oldData.map((v3,i3) => (v3 + offsetValue[i3] * v)),
                });
            },
            finishFunc: () => {
                oldData = seriseData.map(v2 => v2);
                this.entInfoNumber++;
                if(this.entInfoNumber > 2) {
                    this.entInfoNumber = 0;
                }
                chartData = subjectDatas.regionEnt[this.entInfoNumber];
                xData = Object.keys(chartData.ent);
                seriseData = Object.values(chartData.ent);
                offsetValue = seriseData.map((v3,i3) => (v3 - oldData[i3]));

                this.htAnims.enterprise = startAnim(enterpriseParam);
            }
        };
        this.htAnims.enterprise = startAnim(enterpriseParam);

        // ////
        // 右一动画
        let infoIndex = 1;
        let infoNextIndex = 2;
        const infoParam = {
            delay: 1000,
            duration: 1000,
            easing: t => t,
            action: v => {
                this.parkInfoPanel.a(`opacity${infoNextIndex}`, v);
                this.parkInfoPanel.a(`opacity${infoIndex}`, 1 - v);
            },
            finishFunc: () => {
                infoIndex++;
                infoNextIndex++;
                if(infoIndex > 3) {
                    infoIndex = 1;
                }
                if(infoNextIndex > 3) {
                    infoNextIndex = 1;
                }
                this.htAnims.infoAnim = startAnim(infoParam);
            }
        };
        this.htAnims.infoAnim = startAnim(infoParam);

        // 右二的事件列表的滚动动画
        this.htAnims.tableRoll = runTableScrollAnim(this.parkEventPanel, {
            loop: true,
            dir: -1,
            // delay: 0,
            // duration: 3000
        });
    }

    /**
     * 停止移除 2D 上的动画
     */
    stop2DAnim() {
        Object.values(this.htAnims).forEach(anim => {
            anim.pause();
        });
        this.htAnims = {};
        this.parkEventPanel.a('ht.translateY', 0);
    }

    /**
     * 开启园区下雪
     */
    openSceneSnow() {
        const map = this.main.pageMap.map;
        map.addSceneSnow();
    }

    /**
     * 关闭园区下雪
     */
    closeSceneSnow() {
        const map = this.main.pageMap.map;
        map.removeSceneSnow();
    }

    /**
     * 开启园区下雨
     */
    openSceneRain() {
        const map = this.main.pageMap.map;
        map.addSceneRain();
    }

    /**
     * 关闭园区下雨
     */
    closeSceneRain() {
        const map = this.main.pageMap.map;
        map.removeSceneRain();
    }

    /**
     * 开启园区的漫游
     */
    startRoamPark() {
        const {
            main,
            dm
        } = this;
        const map = main.pageMap.map;
        // 关闭路口监控(互斥)
        const trafficIntersection = dm.getDataByTag('trafficIntersection');
        trafficIntersection.a('active', false);
        trafficIntersection.s('state', '默认');
        this.closeIntersectionMonitoring();
        runRoamByPath(map, ROAM_PATH_CONFIG, 0);
    }

    /**
     * 停止园区的漫游
     */
    stopRoamPark() {
        const pageMap = this.main.pageMap;
        pageMap.setHomeView();
    }

    /**
     * 开启交通路口监控
     */
    openIntersectionMonitoring() {
        const {
            main,
            dm
        } = this;
        const pageMap = main.pageMap;
        const map = pageMap.map;
        
        map.flyTo({
            heading: 325.09043488575645,
            height: 40.56966049464445,
            pitch: -12.836025496732068,
            position: [118.04160554043364, 24.615823380805075],
            roll: 6.281694942911676,
            animation: {
                duration: 2000
            }
        }, () => {
            // 定位之后的处理
            // 在路口中间加一个切换到人工建模的场景点
            const intersectionPoint = new ht.cesium.Node({
                id: 'intersectionPoint',
                position: [118.04109428421599, 24.61648331943263],
                height: 21.02287657170873,
                scale: 1,
                nodeRender: 'GIS_HT',
            });
            intersectionPoint.s({
                'interactive': true,
                '3d.selectable': true,
                '3d.movable': false,
                '3d.visible': true,
                'shape3d': 'billboard',
                'shape3d.autorotate': true,
                'shape3d.fixSizeOnScreen': true,
                'shape3d.image': 'symbols/smart-park/map/园区交通.json',
                'shape3d.reverse.cull': true,
                'shape3d.transparent': true,
                'texture.cache': false,
                'wf.visible': false
            });
            intersectionPoint.a('name', config.locale === 'en' ? 'Traffic' : '园区交通');
            map.add(intersectionPoint);
            this.intersectionPoint = intersectionPoint;
            // 车辆轨迹加载
            if(this.subjectDatas) {
                let carPaths = this.subjectDatas.carPaths;
                console.log(carPaths);
                carPaths.paths.forEach(carInfo => {
                    const lnglat = carInfo.carPosition;
                    const carNode = new ht.cesium.Node({
                        id: carInfo.id,
                        position: lnglat,
                        scale: 0.0008,
                        nodeRender: 'GIS_HT',
                    });
                    carNode.s({
                        'interactive': false,
                        '3d.selectable': false,
                        '3d.movable': false,
                        '3d.visible': true,
                        'shape3d': `models/smart-park/${carInfo.carType}.json`,
                        'wf.visible': false
                    });
                    carNode.a('property', carInfo);
                    map.add(carNode);
                    if(carInfo.rotationY) {
                        carNode.rotationY = carInfo.rotationY;
                    }
                    this.movingTrackCars[carInfo.id] = carNode;

                    const carTooltipNode = new ht.cesium.Node({
                        id: carInfo.id + '-tooltip',
                        position: [lnglat[0], lnglat[1]],
                        height: lnglat[2] + 100,
                        scale: 0.03,
                        nodeRender: 'GIS_HT',
                    });
                    carTooltipNode.s({
                        'interactive': false,
                        '3d.selectable': false,
                        '3d.movable': false,
                        '3d.visible': true,
                        'shape3d': 'billboard',
                        'shape3d.autorotate': true,
                        'shape3d.fixSizeOnScreen': false,
                        'shape3d.vector.dynamic': true,
                        'shape3d.image': `symbols/smart-park/map/车辆信息${carInfo.type === '公交车' ? '' : '2'}.json`,
                        'shape3d.reverse.cull': true,
                        'shape3d.transparent': true,
                        'texture.cache': false,
                        'wf.visible': false,
                    });
                    carTooltipNode.a({
                        'property': carInfo,
                        'carNumber': carInfo.carNumber,
                        'carType': carInfo.type,
                        'typeText': carInfo.typeText,
                        'carNormal.visible': carInfo.normal,
                        'carNormal.content': carInfo.content,
                        'carAbnormal.visible': !carInfo.normal,
                        'carAbnormal.content': carInfo.content,
                    });

                    map.add(carTooltipNode);
                    this.movingTrackCarsTooltip[carInfo.id] = carTooltipNode;
                });
                
                let carCount = 0;
                carPaths.action = e => {
                    Object.keys(e).forEach(key => {
                        const node = this.movingTrackCars[key];
                        const tooltipNode = this.movingTrackCarsTooltip[key];
                        if(node) {
                            const p3 = e[key].position;
                            const pp3 = e[key].prePosition;
                            const angle = e[key].angle;
                            node.setPosition3d(p3.x, p3.y, p3.z);
                            tooltipNode.setPosition3d(p3.x, p3.y, p3.z);
                            if(carCount > 10) {
                                if(tooltipNode.a('carType') === '公交车') {
                                    const _value = parseInt(Math.random() * 15 + 20);
                                    tooltipNode.a({
                                        'carNormal.visible': _value < 30,
                                        'carNormal.content': _value,
                                        'carAbnormal.visible':  _value >= 30,
                                        'carAbnormal.content': _value,
                                    });
                                }
                                carCount = 0;
                            }
                            if(angle && pp3 && pp3.x) {
                                node.lookAtByPosition([pp3.x, pp3.y, pp3.z], [p3.x, p3.y, p3.z], 'front');
                            }
                        }
                        carCount++;
                    });
                };
                this.movingTrack = new ht.cesium.MovingTrack(carPaths);
                map.add(this.movingTrack);
            }
        });
    }

    /**
     * 关闭交通路口监控
     */
    closeIntersectionMonitoring() {
        const pageMap = this.main.pageMap;
        pageMap.setHomeView();

        if(this.intersectionPoint) {
            this.intersectionPoint.remove();
            this.intersectionPoint = null;
        }
        if(this.movingTrack) {
            this.movingTrack.remove();
            this.movingTrack = null;
        }
        if(this.movingTrackCars) {
            Object.values(this.movingTrackCars).forEach(car => {
                car && car.remove();
            });
            this.movingTrackCars = {};
            Object.values(this.movingTrackCarsTooltip).forEach(tooltip => {
                tooltip && tooltip.remove();
            });
            this.movingTrackCarsTooltip = {};
        }
    }

    /**
     * 开启路口的视频监控（视频融合）
     */
    openVideoMonitoring() {
        const main = this.main;
        const pageMap = main.pageMap;
        const map = pageMap.map;
        
        if(!this.videoLayer) {
            this.videoLayer = new ht.cesium.Video({
                id: 'video',
                classType: 'CESIUM_3D_TILE',
                image: './data/1.png',
                videoElement: document.getElementById('video1'),
                posotions: [
                    // [118.04110095639098,24.6169827849831],
                    // [118.04060726922802,24.6164379840069],
                    // [118.04108820101183,24.616039784827798],
                    // [118.04158215051422,24.6165982069702],
                    // [118.04051653111374, 24.616185673834742],
                    // [118.04150367778847, 24.616872870218693],
                    // [118.0410245423197, 24.61568917892492],
                    // [118.04110165700679, 24.61708862391876],
                    [118.04109340792368, 24.616470331560564],
                ],
                canvasConfig: {
                    width: 1000,
                    height: 1000
                },
                offsetLngLat: [0.000325,0.000405],
                // imageType: 'DiffuseMap'
                imageType: 'EmissionMap',
                style: {
                    rotation: 233.5 / 180 * Math.PI,
                    stRotation: 233.5 / 180 * Math.PI
                }
            });
            map.add(this.videoLayer);
        }

        map.flyTo({
            heading: 327.3798697790464,
            height: 63.076080267033646,
            pitch: -27.699154313246975,
            position: [118.04148701628856, 24.615901970895134],
            roll: 6.281638357440542,
            animation: {
                duration: 2000
            }
        }, () => {
        });
    }

    /**
     * 关闭路口的视频监控
     */
    closeVideoMonitoring() {
        const pageMap = this.main.pageMap;
        pageMap.setHomeView();

        if(this.videoLayer) {
            this.videoLayer.remove();
            this.videoLayer = null;
        }
    }

    /**
     * 显示路口仿真的场景
     */
    showIntersectionScene() {
        const dm = this.dm;
        const iframeDialog = dm.getDataByTag('iframeDialog');
        const iframePage = dm.getDataByTag('iframePage');
        const __url = window.location.href;
        if(__url.indexOf('index') > -1) {
            __url = __url.split('index')[0];
        }
        iframeDialog.s('2d.visible', true);
        iframePage.a('url', __url + 'crossroads-index.html');
    }

    /**
     * 清除关闭所有动画及数据更新
     */
    clear() {   
		this.closeSceneSnow();
		this.closeSceneRain();
		this.closeIntersectionMonitoring();
        this.closeVideoMonitoring();

        this.stop2DAnim();
    }
}